import { makeStyles } from 'tss-react/mui';
import { ExternalLink } from '@features/workspace/components/shared/external-link';
import { Box, Divider } from '@mui/material';
import { useId } from 'react';

const useStyles = makeStyles<any>()({
  label: {
    fontWeight: 400,
    fontSize: '14px',
    color: '#4B4B4B',
  },
  value: {
    fontSize: '12px',
    color: '#838383',
  },
});

type LinkListProps = {
  properties: Array<any>;
};

export function LinkList({ properties }: LinkListProps) {
  const { classes } = useStyles(null);

  const id = useId();

  return (
    <>
      {properties.map((item: any, iItem: number) => (
        <Box key={`${id}-${item?.link}-${iItem}`}>
          <Box display="flex" py={2}>
            <Box className={classes.label} display="flex" width={0.5}>
              {item?.header}
            </Box>
            <Box
              className={classes.value}
              display="flex"
              justifyContent="flex-end"
              width={0.5}
            >
              {item?.link !== null && item?.link !== '' ? (
                <ExternalLink text="Access link" url={item?.link} />
              ) : (
                <>{item?.text}</>
              )}
            </Box>
          </Box>
          <Divider
            style={{
              marginLeft: '-10px',
              width: 'calc(100% + 20px)',
            }}
          />
        </Box>
      ))}
    </>
  );
}
